

function isPembinaData(roles){
  if(Array.isArray(roles) &&  roles.length){
    return roles.includes("ROLE_PEMBINA_DATA_PUSAT") || roles.includes("ROLE_PEMBINA_DATA_PROVINSI") || roles.includes("ROLE_PEMBINA_DATA_KABKOTA");
  }
  return false
}
function isWalidata(roles){
  if(Array.isArray(roles) &&  roles.length){
    return roles.includes("ROLE_WALIDATA_PUSAT") || roles.includes("ROLE_WALIDATA_PROVINSI") || roles.includes("ROLE_WALIDATA_KABKOTA");
  }
  return false
}
function isPembinaDataPusat(roles){
  if(!roles || roles.length==0) return false
  return roles.includes("ROLE_PEMBINA_DATA_PUSAT");
}
function isPembinaDataProvinsi(roles){
  return roles.includes("ROLE_PEMBINA_DATA_PROVINSI")
}
function isPembinaDataKabupatenKota(roles){
  return roles.includes("ROLE_PEMBINA_DATA_KABKOTA")
}

function isWalidataPusat(roles){
  return roles.includes("ROLE_WALIDATA_PUSAT");
}
function isWalidataProvinsi(roles){
  return roles.includes("ROLE_WALIDATA_PROVINSI")
}
function isWalidataKabupatenKota(roles){
  return roles.includes("ROLE_WALIDATA_KABKOTA")
}

function isProdusenData(roles){
  return roles.includes("ROLE_PRODUSEN_DATA_PUSAT") || roles.includes("ROLE_PRODUSEN_DATA_PROVINSI") || roles.includes("ROLE_PRODUSEN_DATA_KABKOTA");
}
function isProdusenDataPusat(roles){
  return roles.includes("ROLE_PRODUSEN_DATA_PUSAT");
}
function isProdusenDataProvinsi(roles){
  return roles.includes("ROLE_PRODUSEN_DATA_PROVINSI")
}
function isProdusenDataKabupatenKota(roles){
  return roles.includes("ROLE_PRODUSEN_DATA_KABKOTA")
}
function isSuperAdmin(roles){
  return roles.includes("ROLE_SUPERADMIN")
}

export {
  isPembinaData, isPembinaDataPusat, isPembinaDataProvinsi, isPembinaDataKabupatenKota,
  isWalidata, isWalidataPusat, isWalidataProvinsi, isWalidataKabupatenKota,
  isProdusenData, isProdusenDataPusat, isProdusenDataProvinsi, isProdusenDataKabupatenKota,
  isSuperAdmin

};

